export enum ContestMemberStatus {
    Invited = 'Invited',
    Joined = 'Joined',
    Quit = 'Quit'
}
